import React, { useMemo, useState } from "react";
import { CardBody, TabContent, TabPane } from "reactstrap";
import { TabContentProp } from "../../types/forms/form-controls/FormsControls";
import { H5 } from "../../AbstractElements";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import { Input, Label } from "reactstrap";
import { getIPColumns } from "../../data/ip-management/IPDataList";
import { tableHeaderStyles } from "../../styles/ReactSelectStyles";

// Sample IP data for different tabs
export const ipDataList = {
  whitelist: [
    {
      id: 1,
      ipAddress: "192.168.1.100",
      lastActivity: "Login",
      status: "Active",
      dateTime: "2024-06-10 02:30 PM",
      location: "India",
      hits: "1",
    },
    {
      id: 2,
      ipAddress: "10.0.0.50",
      lastActivity: "File Upload",
      status: "Active",
      dateTime: "2024-06-10 11:15 AM",
      location: "Germany",
      hits: "1",
    },
    {
      id: 3,
      ipAddress: "172.16.0.25",
      lastActivity: "Settings Change",
      status: "Active",
      dateTime: "2024-06-09 04:45 PM",
      location: "USA",
      hits: "1",
    },
    {
      id: 4,
      ipAddress: "192.168.1.100",
      lastActivity: "Login",
      status: "Active",
      dateTime: "2024-06-10 02:30 PM",
      location: "India",
      hits: "1",
    },
    {
      id: 5,
      ipAddress: "10.0.0.50",
      lastActivity: "File Upload",
      status: "Active",
      dateTime: "2024-06-10 11:15 AM",
      location: "Germany",
      hits: "1",
    },
    {
      id: 6,
      ipAddress: "172.16.0.25",
      lastActivity: "Settings Change",
      status: "Active",
      dateTime: "2024-06-09 04:45 PM",
      location: "USA",
      hits: "1",
    },
    {
      id: 7,
      ipAddress: "172.16.0.25",
      lastActivity: "Settings Change",
      status: "Active",
      dateTime: "2024-06-09 04:45 PM",
      location: "USA",
      hits: "1",
    },
    {
      id: 8,
      ipAddress: "192.168.1.100",
      lastActivity: "Login",
      status: "Active",
      dateTime: "2024-06-10 02:30 PM",
      location: "India",
      hits: "1",
    },
    {
      id: 9,
      ipAddress: "10.0.0.50",
      lastActivity: "File Upload",
      status: "Active",
      dateTime: "2024-06-10 11:15 AM",
      location: "Germany",
      hits: "1",
    },
    {
      id: 10,
      ipAddress: "172.16.0.25",
      lastActivity: "Settings Change",
      status: "Active",
      dateTime: "2024-06-09 04:45 PM",
      location: "USA",
      hits: "1",
    },
  ],
  blacklist: [
    {
      id: 1,
      ipAddress: "203.0.113.45",
      lastActivity: "Blocked",
      status: "Blocked",
      dateTime: "2024-06-08 09:00 AM",
      location: "Russia",
      hits: "1",
    },
    {
      id: 2,
      ipAddress: "198.51.100.123",
      lastActivity: "Suspicious Login",
      status: "Blocked",
      dateTime: "2024-06-07 10:30 PM",
      location: "China",
      hits: "1",
    },
  ],
  nonList: [
    {
      id: 1,
      ipAddress: "203.0.113.100",
      lastActivity: "Unknown",
      status: "Blocked",
      dateTime: "2024-06-06 01:00 PM",
      location: "Brazil",
      hits: "1",
    },
    {
      id: 2,
      ipAddress: "198.51.100.200",
      lastActivity: "New Connection",
      status: "Active",
      dateTime: "2024-06-05 03:20 PM",
      location: "UK",
      hits: "1",
    },
  ],
};

// Status badge component

const IPTabContent: React.FC<TabContentProp> = ({ basicTab }) => {
  const { t } = useTranslation();
  const [filterText, setFilterText] = useState("");

  // Get data based on active tab
  const getTabData = () => {
    switch (basicTab) {
      case "1":
        return ipDataList.whitelist;
      case "2":
        return ipDataList.blacklist;
      case "3":
        return ipDataList.nonList;
      default:
        return [];
    }
  };

  const data = getTabData();

  // Filter data based on search text
  const filteredItems = data.filter((item) => {
    const search = filterText.toLowerCase();
    return item.ipAddress.toLowerCase().includes(search);
  });

  // Search component
  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div
        id="basic-9_filter"
        className="dataTables_filter d-flex align-items-center"
      >
        <Label className="me-2">{t("Search") || "Search"}:</Label>
        <Input
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setFilterText(e.target.value)
          }
          type="search"
          value={filterText}
          placeholder={t("SearchIPAddress") || "Search IP Address..."}
        />
      </div>
    );
  }, [filterText, t]);

  // Get tab header based on active tab
  const getTabHeader = () => {
    switch (basicTab) {
      case "1":
        return t("WhiteList") || "White List";
      case "2":
        return t("BlackList") || "Black List";
      case "3":
        return t("nonList") || "Non-List";
      default:
        return "";
    }
  };

  return (
    <TabContent activeTab={basicTab}>
      <TabPane tabId={basicTab}>
        <CardBody className="px-0 pb-0">
          <div className="user-header">
            <H5 className="f-w-700">{getTabHeader()}</H5>
          </div>

          <div className="list-product">
            <div className="table-responsive">
              <DataTable
                data={filteredItems}
                columns={getIPColumns(t, basicTab)}
                striped
                pagination
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
                pointerOnHover
                highlightOnHover
                customStyles={tableHeaderStyles}
                noDataComponent={
                  <div className="text-center p-4 text-muted">
                    {t("NoIPDataFound") || "No IP data found."}
                  </div>
                }
              />
            </div>
          </div>
        </CardBody>
      </TabPane>
    </TabContent>
  );
};

export default IPTabContent;
